import { render, staticRenderFns } from "./plusBoldIcon.vue?vue&type=template&id=6c435bfe&"
import script from "./plusBoldIcon.vue?vue&type=script&lang=js&"
export * from "./plusBoldIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports